import { ReactElement } from 'react'

/**
 * Right-side skeleton shown while the inbox is loading its first sync.
 * Replaces the "No messages yet" empty state for that window so the empty
 * state doesn't flash between mount and the first list of conversations
 * arriving from the server.
 */
export function InboxSkeleton(): ReactElement {
  return (
    <div className="flex h-full w-full flex-col gap-y-4 bg-surface p-10" aria-hidden>
      <div className="flex items-center gap-3">
        <div className="h-9 w-9 animate-pulse rounded-full bg-surface-muted" />
        <div className="h-4 w-40 animate-pulse rounded bg-surface-muted" />
      </div>
      <div className="mt-4 flex flex-col gap-y-4">
        <SkeletonBubble side="left" widthClass="w-2/3" />
        <SkeletonBubble side="right" widthClass="w-1/2" />
        <SkeletonBubble side="left" widthClass="w-3/4" />
        <SkeletonBubble side="right" widthClass="w-2/5" />
      </div>
    </div>
  )
}

function SkeletonBubble({ side, widthClass }: { side: 'left' | 'right'; widthClass: string }): ReactElement {
  return (
    <div className={side === 'right' ? 'flex justify-end' : 'flex justify-start'}>
      <div className={`h-10 ${widthClass} animate-pulse rounded-2xl bg-surface-muted`} />
    </div>
  )
}
